import { UserRole } from '~/types/account'

export const useWishlist = () => {
  const canUseWishlist = computed(() => {
    const { user } = useSAuth()
    return [UserRole.Customer, UserRole.Demonstrator].includes(user.value?.role)
  })
  return { canUseWishlist }
}